import { create } from 'zustand';

const STORAGE_KEY = '2enbota_guided_tour_step';

type TourStep =
  | 'nav-study'
  | 'select-mc'
  | 'mc-card'
  | 'mc-result'
  | 'finish';

interface GuidedTourState {
  active: boolean;
  step: TourStep | null;
  startTour: () => void;
  nextStep: () => void;
  endTour: () => void;
}

function getSavedStep(): TourStep | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw || raw === 'done' || raw === 'finish') return null;
    return raw as TourStep;
  } catch {
    return null;
  }
}

function saveStep(step: TourStep | 'done' | null) {
  try {
    if (step) localStorage.setItem(STORAGE_KEY, step);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

const STEP_ORDER: TourStep[] = [
  'nav-study',
  'select-mc',
  'mc-card',
  'mc-result',
  'finish',
];

export const useGuidedTourStore = create<GuidedTourState>((set, get) => ({
  active: false,
  step: null,

  startTour: () => {
    const first = STEP_ORDER[0];
    saveStep(first);
    set({ active: true, step: first });
  },

  nextStep: () => {
    const { step } = get();
    if (!step) return;
    const idx = STEP_ORDER.indexOf(step);
    const next = STEP_ORDER[idx + 1];
    if (next) {
      saveStep(next);
      set({ step: next });
    } else {
      saveStep('done');
      set({ active: false, step: null });
    }
  },

  endTour: () => {
    saveStep('done');
    set({ active: false, step: null });
  },
}));
